<template>
  <form class="contact_form" novalidate @submit.prevent="submit">
    <label class="field">
      <span class="field_label">Imię i nazwisko</span>
      <input v-model="form.name" type="text" name="name" autocomplete="name" />
    </label>

    <div class="field_row">
      <label class="field">
        <span class="field_label">Telefon</span>
        <input v-model="form.phone" type="tel" name="phone" autocomplete="tel" />
      </label>

      <label class="field">
        <span class="field_label">Adres e-mail<em>*</em></span>
        <input v-model="form.email" type="email" name="email" autocomplete="email" required />
      </label>
    </div>

    <label class="field">
      <span class="field_label">Marka / model</span>
      <input v-model="form.car" type="text" name="car" />
    </label>

    <label class="consent">
      <input v-model="form.consent" type="checkbox" required />
      <span>
        Wyrażam zgodę na przetwarzanie moich danych osobowych podanych w formularzu
        kontaktowym w celu otrzymania odpowiedzi na przesłane zapytanie, zgodnie z
        <router-link to="/polityka-prywatnosci/">Polityka prywatności</router-link><em>*</em>
      </span>
    </label>

    <button class="site_button" type="submit" :disabled="sending">
      {{ sending ? 'Wysyłanie…' : 'Wyślij zapytanie' }}
    </button>

    <p v-if="message" class="form_message" :class="{ is_error: failed }" role="status">{{ message }}</p>
  </form>
</template>

<script>
// The "ask about a car" form.
//
// WordPress rendered this as a Kadence advanced form that posted to
// admin-ajax.php. The markup is ours now; the endpoint still has to be wired
// to a backend before it can deliver anything — see the README.

const ENDPOINT = '/wp-admin/admin-ajax.php'

export default {
  name: 'SiteContactForm',

  data() {
    return {
      sending: false,
      failed: false,
      message: '',
      form: { name: '', phone: '', email: '', car: '', consent: false },
    }
  },

  methods: {
    async submit() {
      if (!this.form.email || !this.form.consent) {
        this.failed = true
        this.message = 'Podaj adres e-mail i zaakceptuj zgodę na przetwarzanie danych.'
        return
      }

      this.sending = true
      this.message = ''

      try {
        const response = await fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.form),
        })
        if (!response.ok) throw new Error(response.status)

        this.failed = false
        this.message = 'Dziękujemy — odezwiemy się w ciągu 24 godzin.'
        this.form = { name: '', phone: '', email: '', car: '', consent: false }
      } catch (error) {
        this.failed = true
        this.message = 'Nie udało się wysłać zapytania. Zadzwoń: 509 230 500.'
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style scoped>
.contact_form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px;
  border: 1px solid rgba(209, 207, 207, 0.13);
  border-radius: var(--radius);
}

.field {
  display: flex;
  flex-direction: column;
}

.field_row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

.field_label {
  margin-bottom: 10px;
  color: var(--ink-invert-soft);
  font-size: 14.4px;
  text-transform: uppercase;
}

.field_label em,
.consent em {
  color: #b32d2e;
  font-style: normal;
}

.contact_form input[type='text'],
.contact_form input[type='tel'],
.contact_form input[type='email'] {
  padding: 12px 15px;
  border: 1px solid rgba(209, 207, 207, 0.29);
  border-radius: 10px;
  background: rgba(51, 50, 50, 0.45);
  color: #fff;
  font: inherit;
}

.contact_form input:focus {
  border-color: var(--accent);
  outline: none;
}

.consent {
  display: flex;
  align-items: baseline;
  gap: 5px;
  color: #fff;
  font-size: 12px;
  line-height: 1.3;
}

.consent input {
  accent-color: var(--accent);
}

.consent a {
  color: var(--accent);
}

.contact_form .site_button {
  width: 100%;
}

.form_message {
  color: #8fd694;
  font-size: 14px;
}

.form_message.is_error {
  color: #ff8a80;
}

@media (max-width: 600px) {
  .contact_form {
    padding: 20px;
  }

  .field_row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>
